const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

export const delay = (delayed, ms) => Promise.all([delayed, sleep(ms)]).then(([data]) => data)
